import { Injectable } from '@angular/core'

import { UtilitaService } from 'src/app/services/utilita.service';
import { Router } from '@angular/router'

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'

import { AuthGuard } from '../auth.guard'
//import { Md5 } from 'md5-typescript'
import { MatSnackBar } from '@angular/material/snack-bar';
import { Md5 } from 'md5-typescript';


interface User {
  username: string
  password: string
  idUtenteRuolo: number
  idUtente: number
  nome: boolean
  cognome: string
  email: string
  isRuoloFiltroRegistroPresenze: number
  token: string
  IdCliente: number
}

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  userData: any
  static loggedIn = false;
  constructor(
    private http: HttpClient,
    public srvUtilita: UtilitaService,
    public router: Router,
    private snackBar: MatSnackBar
  ) {

  }

  login(username: string, password: string) {
 
    password = Md5.init(password);
    const userLog = {
      pUserName: username,
      pPassword: password,
      software: 2
    }
    return this.http.post<any>(this.srvUtilita.getAPI_BASE_PATH() + 'Login/CheckLogin', userLog)
  }

  SignIn(username: string, password: string) {
   
    this.login(username, password).subscribe((res: any) => {
     
      res = res;
      console.log("res", res);
      const userAngular = {
        username: res.Email,
        Email: res.Email,
        Nome: res.Nome,
        Cognome: res.Cognome,
        password: "",
        idUtente: res.Id,
        token: res.token
  }
      /*valido solo in debug poi eliminare altrimenti non ha senso il cript*/
      localStorage.setItem('username', JSON.stringify(userAngular))
      localStorage.setItem('usernameUtente', JSON.stringify(userAngular))
      /*******/
       console.log('loggato');

      AuthService.loggedIn = true;
 

      if (res.Nome == "ResettaPassword")
        this.router.navigate(['/impostapasswordperaccesso']);
      else
        this.router.navigate(['/dashboard']);
      
    
    },
      (err: any) => {
     
        this.showMessage(err.error.Message,'OK');
  })

 

  }
  public iIsLoggedIn() {
    return AuthService.loggedIn;
  }



  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
  async SignOut() {
    localStorage.removeItem('username')
    localStorage.removeItem('user')
    AuthService.loggedIn = false;
    this.router.navigate(['/login'])
  }

  showMessageAlert(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 100000 })
  }

}
